import API from '../../../api'
import { storage } from '../../../services/local-storage'

export default {
  state: {
    projects: storage.projects || [],
    currentProjectId: storage.currentProjectId || null,
    currentProjectFormId: storage.currentProjectFormId || null,
    isShowArchive: storage.isShowArchive || false
  },
  mutations: {
    setArchiveShow(state, isShowArchive) {
      storage.isShowArchive = isShowArchive
      state.isShowArchive = isShowArchive
    },
    setProjects(state, projects) {
      projects
        .sort((p1, p2) => p2.endpoints.length - p1.endpoints.length)
        .sort((p1, p2) => p1.archive - p2.archive)
      storage.projects = projects
      state.projects = projects
    },
    setCurrentProjectId(state, projectId) {
      storage.currentProjectId = projectId
      state.currentProjectId = projectId
    },
    setCurrentProjectFormId(state, formId) {
      storage.currentProjectFormId = formId
      state.currentProjectFormId = formId
    },

    renameProject(state, { id, name }) {
      const target = state.projects.find((project) => project.id === id)
      if (target) {
        target.name = name
      }
    },

    changeArchiveState(state, { id, archive }) {
      const target = state.projects.find((project) => project.id === id)
      if (target) {
        target.archive = archive
      }
    },

    projectSubmissionRead(state, { projectId, endpointId }) {
      const project = state.projects.find((project) => project.id === projectId)
      if (project) {
        const endpoint = project.endpoints.find(
          (endpoint) => endpoint.id === endpointId
        )
        if (endpoint) {
          endpoint.submissions_count -= 1
        }
      }
    },

    setProjectSubmissionsCount(state, { projectId, endpointId, count }) {
      const project = state.projects.find((project) => project.id === projectId)
      if (project) {
        const endpoint = project.endpoints.find(
          (endpoint) => endpoint.id === endpointId
        )
        if (endpoint) {
          endpoint.submissions_count = count
        }
      }
    }
  },
  actions: {
    async fetchProjects({ commit }) {
      commit('setProjects', await API.projects.all())
      return true
    },
    async unarchiveProject({ commit }, project) {
      try {
        const response = await API.projects.restore({
          projectId: project.id
        })
        if (!response.error) {
          commit('changeArchiveState', {
            id: project.id,
            archive: 0
          })
        }
      } catch (err) {
        console.error(err)
      }
    }
  },
  getters: {
    currentProject(state) {
      const project = state.projects.find(
        (project) => project.id === state.currentProjectId
      )
      if (project) {
        return project
      } else if (state.projects.length > 0) {
        return state.projects[0]
      } else {
        return null
      }
    },
    currentProjectForm(state, getters) {
      const project = getters.currentProject
      if (project) {
        const endpoint = project.endpoints.find(
          (form) => form.id === state.currentProjectFormId
        )
        if (endpoint) {
          return endpoint
        } else {
          return {
            id: 'all',
            form_name: 'All'
          }
        }
      } else {
        return null
      }
    },
    projects(state) {
      return state.projects
    },
    activeProjects(state) {
      return state.projects.filter((project) => project.archive === 0)
    },
    inactiveProjects(state) {
      return state.projects.filter((project) => project.archive === 1)
    },
    isShowArchive(state) {
      return state.isShowArchive
    }
  }
}
